
<template>
  <div class="template-footer-nine pt-100">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-lg-3 col-md-6 col-sm-5">
          <div class="single-footer-widget">
            <router-link to="/" class="logo">
              <img src="../../assets/images/logo.png" alt="logo">
            </router-link>
            <p>Desenvolvemos soluções digitais inovadoras para impulsionar o crescimento do seu negócio. O RaptorCRM é nossa expertise em gestão de relacionamento com clientes.</p>
            <ul class="social-links">
              <li>
                <a href="https://www.facebook.com/fontesbusiness" target="_blank">
                  <i class="flaticon-facebook-app-symbol"></i>
                </a>
              </li>
              <li>
                <a href="https://www.instagram.com/fontesbusiness" target="_blank">
                  <i class="flaticon-instagram"></i>
                </a>
              </li>
              <li>
                <a href="https://www.linkedin.com/company/fontes-business" target="_blank">
                  <i class="flaticon-linkedin"></i>
                </a>
              </li>
              <li>
                <a href="https://wa.me/5511999999999" target="_blank">
                  <i class="flaticon-whatsapp"></i>
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div class="col-lg-2 col-md-6 col-sm-3">
          <div class="single-footer-widget pl-2">
            <h3>RaptorCRM</h3>
            <ul class="links-list">
              <li><router-link to="/raptor-crm">Sobre o Sistema</router-link></li>
              <li><router-link to="/raptor-crm#funcionalidades">Funcionalidades</router-link></li>
              <li><router-link to="/raptor-crm#precos">Planos e Preços</router-link></li>
              <li><router-link to="/raptor-crm#depoimentos">Depoimentos</router-link></li>
              <li><router-link to="/contact">Demonstração</router-link></li>
            </ul>
          </div>
        </div>
        <div class="col-lg-2 col-md-3 col-sm-4">
          <div class="single-footer-widget">
            <h3>Links Úteis</h3>
            <ul class="links-list">
              <li><router-link to="/about-us">Sobre Nós</router-link></li>
              <li><router-link to="/services">Nossos Serviços</router-link></li>
              <li><router-link to="/team">Nossa Equipe</router-link></li>
              <li><router-link to="/blog-grid">Blog</router-link></li>
              <li><router-link to="/contact">Contato</router-link></li>
            </ul>
          </div>
        </div>
        <div class="col-lg-2 col-md-3 col-sm-4">
          <div class="single-footer-widget">
            <h3>Suporte</h3>
            <ul class="links-list">
              <li><router-link to="/faq">FAQ</router-link></li>
              <li><router-link to="/contact">Suporte Técnico</router-link></li>
              <li><router-link to="/privacy-policy">Política de Privacidade</router-link></li>
              <li><router-link to="/terms-conditions">Termos de Uso</router-link></li>
              <li><router-link to="/contact">Central de Ajuda</router-link></li>
            </ul>
          </div>
        </div>
        <div class="col-lg-3 col-md-6 col-sm-8">
          <div class="single-footer-widget">
            <h3>Newsletter</h3>
            <p>Receba dicas e novidades sobre CRM e vendas.</p>
            <form class="newsletter-form" @submit.prevent="subscribeNewsletter">
              <input
                  type="email"
                  class="input-newsletter"
                  placeholder="Digite seu e-mail"
                  name="EMAIL"
                  v-model="email"
                  required
              >
              <button type="submit" class="btn-style-one red-light-color">
                Inscrever-se <i class="ph-caret-right"></i>
              </button>
            </form>
          </div>
        </div>
      </div>

      <div class="copyright-area">
        <p>
          Copyright @{{currentYear}} Fontes Business. Todos os direitos reservados.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FooterStyleNine',
  data() {
    return {
      currentYear: new Date().getFullYear(),
      email: ''
    };
  },
  methods: {
    subscribeNewsletter() {
      if (this.email) {
        // Aqui você pode implementar a lógica para inscrever no newsletter
        console.log('Inscrevendo email:', this.email);
        alert('Obrigado por se inscrever em nossa newsletter!');
        this.email = '';
      }
    }
  }
}
</script>